<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px', fullScreenBackdrop: true}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <div class="login-signup signup">
      <header class="login-header">
        <h2 class="text-white">Sign up Page</h2>
      </header>
      <form [formGroup]="registrationDetails">
        <div *ngIf="submitted && failedSignUp" class="error" style="text-align: center">{{errorMsg}}</div>
        <div class="col-sm-6 col-md-12 col-lg-12">
          <div class="col-sm-6 col-md-12 col-lg-12">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" required placeholder="Company Name"
                formControlName="companyName" (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div
              *ngIf="registrationDetails.controls.companyName.touched && registrationDetails.controls.companyName.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.companyName.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Company Name is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.companyName.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Company Name must not begin with space
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" required placeholder="First Name"
                formControlName="firstname" (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.firstname.touched && registrationDetails.controls.firstname.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.firstname.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  First name is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.firstname.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  First name must contain alphabets and must not begin with space
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="text" class="form-control" matInput required placeholder="Last Name"
                formControlName="lastname" (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.lastname.touched && registrationDetails.controls.lastname.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.lastname.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Last name is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.lastname.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Last name must not begin with space
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2 col-md-4 col-lg-4">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" placeholder="Cell Phone Number"
                formControlName="phone"  (ngModelChange)="changeRegiatrationFailedStatus();"
                (change)="getlength($event, 1)">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.phone.touched && registrationDetails.controls.phone.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.phone.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Cell Phone number should contain 10 digits
                </div>
              </div>
            </div>
            <div *ngIf="mobileError">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Cell Phone number should contain 10 digits
              </div>
            </div>
            <div *ngIf="errorId == 103 && failedSignUp" class="alert custom-alert-danger" role="alert">{{errorMsgPhone}}
            </div>
            <div *ngIf="errorId == 104 && failedSignUp" class="alert custom-alert-danger" role="alert">{{errorMsgPhone}}
            </div>
          </div>
          <div class="col-sm-2 col-md-5 col-lg-5">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" placeholder="Breakdown Team Phone"
                formControlName="officePhone"  (ngModelChange)="changeRegiatrationFailedStatus();"
                (change)="getlength($event, 2)">
            </mat-form-field>
            <div
              *ngIf="registrationDetails.controls.officePhone.touched && registrationDetails.controls.officePhone.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.officePhone.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Breakdown Team Phone number should contain 10 digits
                </div>
              </div>
            </div>
            <div *ngIf="officeError">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Breakdown Team Phone number should contain 10 digits
              </div>
            </div>
          </div>
          <div class="col-sm-2 col-md-3 col-lg-3">
            <mat-form-field class="full-width">
              <input type="number" matInput class="form-control" placeholder="Extension" formControlName="extension"
                (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
          </div>
          <div class="col-sm-6 col-md-12 col-lg-12">
            <mat-form-field class="full-width">
              <input type="email" matInput class="form-control" required placeholder="Email" formControlName="email"
                uniqueEmail (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.email.touched && registrationDetails.controls.email.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.email.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Email is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.email.errors.uniqueEmail">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Email already exists.
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.email.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Email must be a valid email address
                </div>
              </div>
            </div>
            <div *ngIf="errorId == 101 || errorId == 102 && failedSignUp" class="alert custom-alert-danger"
              role="alert">{{errorMsgEmail}}</div>
          </div>

          <div class="col-sm-6 col-md-12 col-lg-12">
            <mat-form-field class="full-width">
              <input type="email" matInput class="form-control" required placeholder="Billing Email"
                formControlName="billingEmail" uniqueEmail (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div
              *ngIf="registrationDetails.controls.billingEmail.touched && registrationDetails.controls.billingEmail.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.billingEmail.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Billing email is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.billingEmail.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Billing Email must be a valid email address
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="password" matInput class="form-control" required placeholder="Password"
                formControlName="password" (ngModelChange)="changeRegiatrationFailedStatus()" [(ngModel)]="password">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.password.touched && registrationDetails.controls.password.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.password.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Password is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.password.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Password must be of 8 character long having
                  at least one upper case ,one lower case ,one digit,one special character from (#?!@$%^&*-.).
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="password" matInput class="form-control" required placeholder="Confirm Password"
                formControlName="confpassword" [compareEqual]="password"
                (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div
              *ngIf="registrationDetails.controls.confpassword.touched && registrationDetails.controls.confpassword.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.confpassword.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Confirm Password is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.confpassword.errors.compareEqual">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Password Do Not Match.
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-12 col-lg-12">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" required placeholder="Billing Address"
                formControlName="address" (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.address.touched && registrationDetails.controls.address.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.address.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Billing Address is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.address.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Billing Address must contain valid characters and must not begin with space
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" (keyup)="zipCodeEntered()" required
                placeholder="Zip Code" formControlName="zip" (ngModelChange)="changeRegiatrationFailedStatus()"
                maxlength="9">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.zip.touched && registrationDetails.controls.zip.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.zip.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Zip Code is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.zip.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Zip code should contain digits only
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field class="full-width">
              <input type="text" matInput class="form-control" required placeholder="City" formControlName="city"
                (ngModelChange)="changeRegiatrationFailedStatus()">
            </mat-form-field>
            <div *ngIf="registrationDetails.controls.city.touched && registrationDetails.controls.city.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.city.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  City is required
                </div>
              </div>
              <div *ngIf="registrationDetails.controls.city.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Please enter valid city
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-6 col-lg-6">
            <mat-form-field>
              <mat-select matNativeControl required placeholder="State" formControlName="stateTypeId"
                (ngModelChange)="changeRegiatrationFailedStatus()">
                <mat-option *ngFor="let st of preSignUpSTDetails" value="{{st.StateTypeCode}}">{{st.StateTypeName}} -
                  {{st.StateTypeCode}}</mat-option>
              </mat-select>

            </mat-form-field>
            <div
              *ngIf="registrationDetails.controls.stateTypeId.touched && registrationDetails.controls.stateTypeId.errors"
              class="error">
              <div *ngIf="registrationDetails.controls.stateTypeId.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  State is required
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-info full-width" (click)="register()" [disabled]="isFormSubmitted">Sign Up</button>
          </div>
          <div>
            <div class="btm-form">
              <p>Already have an Account? Click<a routerLink="/login"> here</a> to login</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>
